import {notification} from 'antd'
import {CloseOutlined} from "@ant-design/icons";
import styled from 'styled-components'

const Description = styled.span`
  white-space: pre-line;
`

export const Notification = (type, description, title = '', icon = null) => {
    //success, error,info,warning
    notification[type](
        {
            message: title,
            description: <Description >{description}</Description>
            // duration:99999
        }
    )
}